import s from './Member.module.sass'

import { ImageBox } from 'shared-components'

function Member({ member }: any) {
    const { name, position, image } = member

    return (
        <div className={s.Member}>
            <div className={s.Image}>
                <ImageBox image={image} alt={name} width={220} height={260} />
            </div>
            <div className={s.MemberInfo}>
                {name && <h4 dangerouslySetInnerHTML={{ __html: name }} />}
                {position && <span className={'smallCaps manrope'} dangerouslySetInnerHTML={{ __html: position }} />}
            </div>
        </div>
    )
}

export default Member
